/**
 * คีย์สิทธิ์ต่อบทบาท (Tb_Comp_Role_Permission.Permission_Key)
 * รูปแบบ: page.{slug}.{create|read|update|delete}
 * ใช้กับหน้ากำหนดสิทธิ์บทบาท และกรองเมนู/เช็ค path ผ่าน utils/orgAccessPermissions.js
 */

export const PERMISSION_CRUD = [
  { field: "create", label: "สร้าง" },
  { field: "read", label: "ดู" },
  { field: "update", label: "แก้ไข" },
  { field: "delete", label: "ลบ" },
];

function crud(slug) {
  const b = `page.${slug}`;
  return {
    create: `${b}.create`,
    read: `${b}.read`,
    update: `${b}.update`,
    delete: `${b}.delete`,
  };
}

/** @type {{ title: string, pages: Array<{ id: string, label: string, path?: string, create: string, read: string, update: string, delete: string }> }[]} */
export const PERMISSION_MATRIX = [
  {
    title: "ขาย",
    pages: [
      { id: "sale_customer", label: "ลูกค้า", path: "/sale", ...crud("sale_customer") },
      { id: "sale_calendar", label: "ปฏิทินการเข้าพบ", path: "/sale-customer-calendar", ...crud("sale_calendar") },
      { id: "sale_quote", label: "ใบเสนอราคา (รวม /admin-quotelist และ /quotelist/...)", path: "/admin-quotelist", ...crud("sale_quote") },
      { id: "sale_contract", label: "สัญญา", path: "/contractlist", ...crud("sale_contract") },
      { id: "sale_report", label: "ตรวจสอบฝ่ายขาย", path: "/sale-report", ...crud("sale_report") },
    ],
  },
  {
    title: "งานช่าง",
    pages: [
      { id: "job_file", label: "แฟ้มงาน", path: "/jobfile", ...crud("job_file") },
      { id: "job_management", label: "จัดการจ๊อบ", path: "/job-management", ...crud("job_management") },
      { id: "job_payment_record", label: "บันทึกการชำระเงิน", path: "/invoice-record", ...crud("job_payment_record") },
      { id: "job_temp_equipment", label: "อุปกรณ์ชั่วคราว", path: "/temp-equipment", ...crud("job_temp_equipment") },
    ],
  },
  {
    title: "จัดซื้อสินค้า",
    pages: [
      { id: "purchase_order", label: "ใบสั่งซื้อ", path: "/purchase-order", ...crud("purchase_order") },
      { id: "purchase_receipt", label: "ใบรับสินค้า", path: "/product-receipt", ...crud("purchase_receipt") },
      { id: "purchase_voucher", label: "ใบสำคัญจ่าย", path: "/payment-voucher", ...crud("purchase_voucher") },
      { id: "purchase_tax", label: "หนังสือหัก ณ ที่จ่าย", path: "/tax", ...crud("purchase_tax") },
    ],
  },
  {
    title: "คลัง / สต๊อก",
    pages: [
      { id: "stock_overview", label: "ดูสต๊อกสินค้า", path: "/stock/stock-overview", ...crud("stock_overview") },
      { id: "stock_detail", label: "สินค้าแยกตามคลัง", path: "/stock/stock-detail", ...crud("stock_detail") },
      { id: "stock_documents", label: "เอกสารงานคลัง", path: "/stock/stock-documents", ...crud("stock_documents") },
      { id: "stock_withdraw", label: "อนุมัติใบขอเบิก", path: "/withdraw-approval", ...crud("stock_withdraw") },
    ],
  },
  {
    title: "ข้อมูลตั้งต้น",
    pages: [
      { id: "init_company", label: "ข้อมูลบริษัท", path: "/company", ...crud("init_company") },
      { id: "init_org_access", label: "สาขา", path: "/org-access", ...crud("init_org_access") },
      { id: "init_org_roles", label: "สิทธิ์และบทบาท", path: "/org-roles", ...crud("init_org_roles") },
      { id: "init_dept", label: "ข้อมูลแผนก", path: "/dept", ...crud("init_dept") },
      { id: "init_employee", label: "ข้อมูลพนักงาน", path: "/employee", ...crud("init_employee") },
      { id: "init_team", label: "ข้อมูลทีม", path: "/team", ...crud("init_team") },
      { id: "init_creditor", label: "ข้อมูลผู้ขาย / เจ้าหนี้", path: "/creditor", ...crud("init_creditor") },
      { id: "init_aptype", label: "ประเภทเจ้าหนี้", path: "/APtype", ...crud("init_aptype") },
      { id: "init_debtor", label: "ข้อมูลลูกหนี้", path: "/debtor", ...crud("init_debtor") },
      { id: "init_artype", label: "ประเภทลูกหนี้", path: "/ARtype", ...crud("init_artype") },
      { id: "init_item", label: "ข้อมูลสินค้า", path: "/tbsetitem", ...crud("init_item") },
      { id: "init_item_group", label: "หมวดหมู่สินค้า", path: "/tbsetitmgroup", ...crud("init_item_group") },
      { id: "init_warehouse", label: "ข้อมูลคลังสินค้า", path: "/tbsetwh", ...crud("init_warehouse") },
      { id: "init_service", label: "ข้อมูลบริการ", path: "/service", ...crud("init_service") },
      { id: "init_servicestep", label: "ขั้นตอนการบริการ", path: "/servicestep", ...crud("init_servicestep") },
      { id: "init_serviceaddrtype", label: "ประเภทอาคาร", path: "/serviceaddrtype", ...crud("init_serviceaddrtype") },
      { id: "init_servicepurpose", label: "วัตถุประสงค์สถานที่บริการ", path: "/servicepurpose", ...crud("init_servicepurpose") },
      { id: "init_timeunit", label: "หน่วยช่วงเวลา", path: "/timeunit", ...crud("init_timeunit") },
      { id: "init_package", label: "ข้อมูลแพ็คเกจ", path: "/package", ...crud("init_package") },
      { id: "init_car", label: "ข้อมูลรถ", path: "/car", ...crud("init_car") },
      { id: "init_transtype", label: "วิธีการขนส่ง", path: "/transType", ...crud("init_transtype") },
      { id: "init_doctype", label: "ประเภทเอกสาร", path: "/docType", ...crud("init_doctype") },
      { id: "init_delivery_customer", label: "ลูกค้าผูกสายส่ง", path: "/deliveryCustomerInfo", ...crud("init_delivery_customer") },
      { id: "init_delivery_car", label: "รถผูกสายส่ง", path: "/deliveryCarInfo", ...crud("init_delivery_car") },
      { id: "init_cover", label: "ปกและท้ายเอกสาร", path: "/cover", ...crud("init_cover") },
      { id: "stock_management", label: "จัดการคลังสินค้า", path: "/stock/stock-management", ...crud("stock_management") },
      { id: "init_release_notes", label: "รายละเอียดอัปเดต", path: "/release-notes", ...crud("init_release_notes") },
    ],
  },
];

/** Set ของคีย์ที่อยู่ในเมทริกซ์ (ใช้แยกสิทธิ์ custom) */
export function getMatrixKeySet() {
  const s = new Set();
  PERMISSION_MATRIX.forEach((sec) => {
    sec.pages.forEach((p) => {
      PERMISSION_CRUD.forEach(({ field }) => s.add(p[field]));
    });
  });
  return s;
}

export const MATRIX_KEY_SET = getMatrixKeySet();
